var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYotiDigitalIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    "data-qa": "icon",
    "aria-hidden": "true",
    className: "yds-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yoti-svg-DIDxS",
    d: "M22.02 22.02h-7.03v-3.055c2.312-.461 4.06-2.506 4.06-4.95 0-2.446-1.748-4.49-4.06-4.952V5.98h7.03v16.04zM5.98 5.98h7.03v3.083c-2.312.461-4.06 2.506-4.06 4.951s1.748 4.49 4.06 4.951v3.055H5.98V5.98zM14 17.084c-1.693 0-3.069-1.377-3.069-3.07 0-1.692 1.377-3.069 3.069-3.069 1.693 0 3.07 1.377 3.07 3.07 0 1.691-1.377 3.069-3.07 3.069zM4 24h20V4H4v20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yoti-svg-0ggBY",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#yoti-svg-DIDxS"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    href: "#yoti-svg-DIDxS"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYotiDigitalIdIcon);
export default __webpack_public_path__ + "static/media/yoti_digital_id_icon.20119cf036b00fb4881aa6b56f4cb498.svg";
export { ForwardRef as ReactComponent };